import { render } from "./HomeView.vue?vue&type=template&id=4fbd0c6c&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=4fbd0c6c&scoped=true&lang=scss"

import exportComponent from "/Users/phil/Sites/2022lovehate/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd0c6c"]])

export default __exports__